import { cn } from "@babackapp/ui/lib/utils";
import { Button, Column, Row } from "@react-email/components";
import type { ButtonBlockProps } from "./types";
import { getThemeButtonStyle } from "./shared-button-styling";
import { useEmailThemeRadius } from "../../hooks/use-emails-theme-radius";
import { sectionToParent, useThemeContextualColors } from "../../hooks";
import { DEFAULT_FONT } from "../../utils/constants";

export function ButtonEmailRenderer({
  block,
  formatter,
  theme,
  locale,
  defaultLocale,
  section,
  isEditor,
}: ButtonBlockProps & { isEditor?: boolean }) {
  const alignment = block.alignment || "center";
  const font = block.font ?? DEFAULT_FONT;
  const buttonRadius = useEmailThemeRadius(theme, "button");
  const colors = useThemeContextualColors(theme, sectionToParent(section));

  const buttonStyle = getThemeButtonStyle({
    variant: block.properties?.variant || "default",
    theme,
    textColor: colors.text,
  });
  const contentHTML =
    block.content?.[locale]?.text || block.content?.[defaultLocale]?.text;
  const href =
    block.content?.[locale]?.href || block.content?.[defaultLocale]?.href;

  let formattedText =
    !!formatter && contentHTML ? formatter(contentHTML) : contentHTML;
  const formattedHref = !!formatter && href ? formatter(href) : href;

  if (!formattedText?.length) {
    if (isEditor) {
      formattedText = "Ajoutez un label";
    } else {
      return null; // Don't render anything if there's no content and we're not in the editor
    }
  }

  if (!isEditor && !formattedHref?.length) {
    return null; // No link → don't render the button in the email
  }

  return (
    <Row>
      <Column
        className={cn({
          "text-left": alignment === "left",
          "text-center": alignment === "center",
          "text-right": alignment === "right",
        })}
      >
        <Button
          href={formattedHref}
          className={cn("inline-block mx-1 no-underline", buttonRadius)}
          style={{ ...buttonStyle, fontFamily: font } as React.CSSProperties}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: formattedText,
            }}
          />
        </Button>
      </Column>
    </Row>
  );
}
